"use client";
import { getShareApi } from "@/api/config";
import { useEventPoint } from "@/hooks/useEventPoint";
import { isInStandaloneMode } from "@/utils";
import { Local } from "@/utils/storage";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

/**
 * @description 主页初始化
 */
const Page = () => {
    const { eventView } = useEventPoint();

    // 获取分享id
    const searchParams = useSearchParams();
    useEffect(() => {
        // pixel 埋点
        eventView();

        if (!isInStandaloneMode()) {
            Local.setKey("channel_code", window.location.href);
        }
        // 统计访问
        getShareApi({ channel_url: window.location.href });

        const shareId = searchParams.get("share_id");
        if (!shareId || shareId === "xxxxxx") return;
        if (shareId.length !== 8) {
            sessionStorage.removeItem("shareId");
            return;
        }
        sessionStorage.setItem("shareId", shareId);
    }, []);

    return null;
};

export default Page;
